import React from "react"
import { graphql } from "gatsby"
import { useStaticQuery } from "gatsby"

import RenderHtml from "./renderHtml"

const Snippet = ({ id }) => {
	const { snippets } = useStaticQuery(
		graphql`
			query {
				snippets: allMarkdownRemark(
					filter: { fields: { collection: { eq: "snippets" } } }
				) {
					edges {
						node {
							fields {
								id
							}
							htmlAst
						}
					}
				}
			}
		`
	)

	return <RenderHtml withAst={findSnippet(snippets, id)} />
}

function findSnippet(snippets, id) {
	return snippets.edges.map(snippet => snippet.node).filter(node => node.fields.id === id)[0]
}

export default Snippet
